import { useEffect, useRef } from "react";
import { PRODUCTS, waLink } from "@/data/products";
import CrossSection from "@/components/site/CrossSection";
import Reveal from "@/components/site/Reveal";

export default function ProductWall() {
  const gridRef = useRef(null);

  useEffect(() => {
    const cards = gridRef.current?.querySelectorAll(".product-card") ?? [];
    const io = new IntersectionObserver(
      (entries) =>
        entries.forEach((e) => e.target.classList.toggle("in-view", e.isIntersecting)),
      { threshold: 0.45 }
    );
    cards.forEach((c) => io.observe(c));
    return () => io.disconnect();
  }, []);

  return (
    <section className="section-paper" id="products" data-testid="product-wall">
      <Reveal>
        <div className="section-head">
          <span className="mono-tag">01 / PRODUCT WALL</span>
          <h2 className="section-title">DEALS IN</h2>
        </div>
      </Reveal>

      <Reveal delay={0.1}>
      <div className="product-grid" ref={gridRef}>
        {PRODUCTS.map((p, i) => (
          <article className="product-card" key={p.id} data-testid={`product-card-${p.id}`}>
            <span className="mono-tag card-fig">FIG. {String(i + 1).padStart(2, "0")}</span>
            <div className="cs-stage">
              <div className="cs-body">
                <CrossSection product={p} />
                <div className="cs-ghost g1"><CrossSection product={p} ghost /></div>
                <div className="cs-ghost g2"><CrossSection product={p} ghost /></div>
                <div className="cs-ghost g3"><CrossSection product={p} ghost /></div>
              </div>
            </div>
            <h3 className="card-name">{p.name}</h3>
            <p className="card-spec">{p.spec}</p>
            <a
              className="rate-link"
              href={waLink(p.name)}
              target="_blank"
              rel="noopener noreferrer"
              data-testid={`product-rate-link-${p.id}`}
            >
              ASK TODAY&apos;S RATE -&gt;
            </a>
          </article>
        ))}
        <article className="product-card product-card-cta" data-testid="product-card-custom">
          <span className="mono-tag card-fig">FIG. XX</span>
          <h3 className="card-name">ANOTHER SECTION OR SIZE?</h3>
          <p className="card-spec">SEND YOUR REQUIREMENT — WE&apos;LL CONFIRM STOCK &amp; RATE</p>
          <a
            className="rate-link"
            href={waLink()}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="product-rate-link-custom"
          >
            ASK TODAY&apos;S RATE -&gt;
          </a>
        </article>
      </div>
      </Reveal>
    </section>
  );
}
